import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import Select from '@afosto/app-components-react/Select';
import { rbac as rbacApi } from '@afosto/iam/api/Rbac';
import validationSchema from './validations';
import translations from '../UserForm/translations';

const RequestAccessForm = ({ onSubmit, onCancel }) => {
  const intl = useIntl();
  const [availableRoles, setAvailableRoles] = useState([]);

  const form = useForm({
    validationSchema,
    editInline: false,
    defaultValues: {
      signee: '',
      roles: [],
    },
    onCancel,
    onSubmit,
  });

  useEffect(() => {
    let isMounted = true;

    const fetchAvailableRoles = async () => {
      try {
        const systemRolesResponse = await rbacApi.listSystemRoles();
        const { data: systemRolesData = [] } = systemRolesResponse;

        const formattedRoles = Object.values(systemRolesData).reduce(
          (acc, availableRole) => [
            ...acc,
            {
              label: availableRole.name,
              value: availableRole.id,
            },
          ],
          [],
        );

        if (isMounted) {
          setAvailableRoles(formattedRoles);
        }
      } catch (err) {
        if (isMounted) {
          setAvailableRoles([]);
        }
      }
    };

    fetchAvailableRoles();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField name="signee" label={intl.formatMessage(translations.fields.email.label)} />

        <Select
          name="roles"
          label={intl.formatMessage(translations.fields.roles.label)}
          suggestions={availableRoles}
          multiple
        />
      </Form>
    </LoadingWrapper>
  );
};

RequestAccessForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

RequestAccessForm.defaultProps = {
  onSubmit: undefined,
  onCancel: undefined,
};

export default RequestAccessForm;
